"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayErrorMessage = exports.extractMessageFromError = exports.extractMessagesFromErrors = exports.isArrayWithValues = exports.isErrorObject = exports.extractMessageFromApiError = exports.isApiError = void 0;
var react_1 = __importDefault(require("react"));
var isApiError = function (object) {
    var _a;
    return (typeof object === "object" &&
        !!object &&
        object.hasOwnProperty("response") &&
        !!((_a = object.response) === null || _a === void 0 ? void 0 : _a.data));
};
exports.isApiError = isApiError;
var extractMessageFromApiError = function (data) {
    try {
        if (!data)
            return;
        if (typeof data === "string")
            return data;
        try {
            return JSON.stringify(data);
        }
        catch (err) {
            console.error(err);
            return "Failed to parse error";
        }
    }
    catch (allError) {
        console.error(allError);
        return;
    }
};
exports.extractMessageFromApiError = extractMessageFromApiError;
/**
 * Check whether an object contains a message key with a string value
 */
var isErrorObject = function (arg) {
    var _a, _b;
    return !!(((_a = arg) === null || _a === void 0 ? void 0 : _a.message) &&
        typeof ((_b = arg) === null || _b === void 0 ? void 0 : _b.message) === "string");
};
exports.isErrorObject = isErrorObject;
/**
 * Check whether an error contains values:
 * for example, an array of null values [null,null,null] will return false.
 */
var isArrayWithValues = function (arr) {
    return arr.some(function (e) { return !!e; });
};
exports.isArrayWithValues = isArrayWithValues;
/**
 * Extract message prop from an array of errors
 */
var extractMessagesFromErrors = function (errors) {
    var messages = [];
    for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
        var error = errors_1[_i];
        if (exports.isErrorObject(error)) {
            error.message &&
                typeof error.message === "string" &&
                messages.push(error.message);
        }
    }
    return messages;
};
exports.extractMessagesFromErrors = extractMessagesFromErrors;
var extractMessageFromError = function (errors, defaultMessage) {
    var _a, _b;
    // String only
    if (typeof errors === "string") {
        return errors;
    }
    // API Error
    if (exports.isApiError(errors)) {
        return (_b = exports.extractMessageFromApiError((_a = errors.response) === null || _a === void 0 ? void 0 : _a.data)) !== null && _b !== void 0 ? _b : errors.message;
    }
    // Error object
    if (exports.isErrorObject(errors)) {
        return errors.message;
    }
    // Array of error objects
    if (errors instanceof Array && exports.isArrayWithValues(errors)) {
        var messages = exports.extractMessagesFromErrors(errors);
        // If no error messages found, it will return the fragment
        if (messages.length > 0) {
            var concatErrors = messages.join("\n");
            return concatErrors;
        }
    }
    return defaultMessage;
};
exports.extractMessageFromError = extractMessageFromError;
/**
 * Return error messages as children of the component param.
 * @param errors - either a string, error object or array of error objects
 * @param Message - Component with which to render the error message
 */
var displayErrorMessage = function (errors, Message) {
    if (!errors)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var message = exports.extractMessageFromError(errors);
    if (message)
        return react_1.default.createElement(Message, null, message);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.displayErrorMessage = displayErrorMessage;
